export enum enumTipoCRUD {
  INSERIR = 'INSERIR',
  ALTERAR = 'ALTERAR',
  APAGAR = 'APAGAR',
}
